import type { FormRule } from 'antd';
import type { TCreateCargoAddressReq } from 'api/swagger';
import { COORDINATES_REGEX, parseCoordinates } from 'shared/utils/coordinates';
import { isSafeIntValidator } from 'shared/utils/validators/is-safe-integer-validator';
import type { IAddressFormFields } from './types';

export const validationRule: Record<string, FormRule[]> = {
  totalWeight: [
    { required: true, type: 'integer', min: 1, message: 'integer only' },
    ...isSafeIntValidator('Total weight'),
  ],
};

export const optionalCoordinatesRule = (message: string): FormRule => ({
  validator: (_, value?: string) => {
    if (!value?.trim() || COORDINATES_REGEX.test(value.trim())) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(message));
  },
});

export const prepareCargoAddressPayload = (address: IAddressFormFields): TCreateCargoAddressReq => {
  const { coordinates, ...addressFields } = address;
  const { lat, lng } = parseCoordinates(coordinates ?? '');
  const hasCoordinates = lat !== undefined && lng !== undefined;

  return {
    ...addressFields,
    ...(hasCoordinates ? { coordinates: { lat, lng } } : {}),
  };
};

export const prepareOptionalCargoAddressPayload = (
  address?: IAddressFormFields,
): TCreateCargoAddressReq | undefined => {
  return address ? prepareCargoAddressPayload(address) : undefined;
};
